// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-page .info-image-container img {
  max-width: 100%;
}

/*.info-page .button-container:not(.float) {*/
/*  margin-top: 24px;*/
/*}*/
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/base.info.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA,6CAA6C;AAC7C,sBAAsB;AACtB,IAAI","sourcesContent":[".info-page .info-image-container img {\n  max-width: 100%;\n}\n\n/*.info-page .button-container:not(.float) {*/\n/*  margin-top: 24px;*/\n/*}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
